module.exports = __webpack_public_path__ + "assets/images/25-2JtWJmX.jpg";